import React from "react";
import cx from "classnames";
import { Box } from "@picklebet/ui";

import * as styles from "./PickSlipCard.module.scss";

type PickSlipCardProps = {
  message?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
};

const PickSlipCard = ({ message, className, children }: PickSlipCardProps) => (
  <>
    {message && <div>{message}</div>}
    <Box
      className={cx(styles.card, className)}
      childrenClassName={styles.pick}
      hideHeader
    >
      {children}
    </Box>
  </>
);

export { PickSlipCard };
